module.exports = __webpack_public_path__ + "static/media/school-img5.94326400.png";